module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", [_vm._v("\n            default header\n          ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", [_vm._v("\n            default body\n          ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_vm._v("\n             \n            "), _c('button', {
    staticClass: "modal-default-button",
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.close) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": function($event) {
        _vm.$emit('ok');
        _vm.$emit('close')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.ok) + "\n            ")])])], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b0dccad"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
// module id = 248
// module chunks = 1